export const hoursEn = {
  buffers: {
    afterClose: 'after close',
    afterOpen: 'after open',
    beforeClose: 'before close',
    beforeOpen: 'before open',
    startAccepting: 'Start accepting orders {minutes} mins {timing}',
    stopAccepting: 'Stop accepting orders {minutes} mins {timing}',
  },
  dayGroups: {
    weekdays: 'Weekdays',
    weekends: 'Weekends',
  },
  days: {
    fri: 'Fri',
    mon: 'Mon',
    sat: 'Sat',
    sun: 'Sun',
    thu: 'Thu',
    tue: 'Tue',
    wed: 'Wed',
  },
  notifications: {
    'special-hours': {
      create: {
        error: 'Unable to create special hours',
        success: 'Special hours created',
      },
      delete: {
        error: 'Unable to delete special hours',
        success: 'Special hours deleted',
      },
      update: {
        error: 'Unable to update special hours',
        success: 'Special hours updated',
      },
    },
  },
  onlineHours: {
    description: 'The hours a guest can place pickup or delivery orders.',
    sameAsStore: 'Same as store hours',
    title: 'Online hours',
  },
  specialHours: {
    closed: 'Closed',
    description:
      'Dates when your hours of business are different than your regular store hours.',
    open24Hours: 'Open 24 hours',
    title: 'Special hours',
  },
  status: {
    closed: 'Closed',
    open24Hours: 'Open 24 hours',
  },
  storeHours: {
    description:
      'The hours a guest can come in to the store and that are viewable on Google',
    title: 'Store hours',
  },
}
